var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowBoldClose = function SvgIconArrowBoldClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.914 5.828 18.086 3 12 9.086 5.914 3 3.086 5.828l6 6L3 17.914l2.828 2.829 6.086-6.086L18 20.743l2.828-2.829-6-6z",
    clipRule: "evenodd"
  })));
};
export { SvgIconArrowBoldClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC45MTQxIDUuODI4MzlMMTguMDg1NyAzTDExLjk5OTkgOS4wODU2N0w1LjkxNDE1IDNMMy4wODU3MiA1LjgyODM5TDkuMDg1NzcgMTEuODI4NEwzIDE3LjkxNDJMNS44Mjg0IDIwLjc0MjZMMTEuOTE0MiAxNC42NTY5TDE4IDIwLjc0MjZMMjAuODI4NCAxNy45MTQyTDE0LjgyODQgMTEuOTE0MkwyMC45MTQxIDUuODI4MzlaIi8+Cjwvc3ZnPgo=";